import type { FC } from 'react';
import { useState } from 'react';
import { IntlProvider } from 'react-intl';
import { useAsyncEffect } from 'use-async-effect';

import { Loading } from '~/components/Loading/Loading';
import { useConfigurationStore, useLocalizationStore } from '~/stores';

export const IntlWrapper: FC = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const {
    configuration: { lang },
  } = useConfigurationStore();
  const { loadLocalization, networkError, translations } = useLocalizationStore();

  useAsyncEffect(async () => {
    await loadLocalization();
    setIsLoaded(true);
  }, []);

  if (networkError) {
    throw networkError;
  }

  if (!isLoaded) {
    return <Loading />;
  }

  if (!lang) {
    return null;
  }

  return (
    <IntlProvider
      locale={lang}
      messages={translations}
    >
      {children}
    </IntlProvider>
  );
};
